import { useMutation, useQueryClient } from "@tanstack/react-query";
import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,

} from "react";
import { apiOperador, apiWhatsApp } from "../services/api";
import { useModal } from "../hooks/ModalContext";
import { useAuth } from "./AuthContext";
import { AxiosError } from "axios";


interface ChatWhatsAppContextProviderProps {
  children: ReactNode;
}

interface File {
  name: string;
  url: string;
}
export interface ComponentsTemplate {
  type: string,
  parameters: {
    type: string,
    text: string
  }[]
}

export interface TemplateProps {
  namespace: string,
  name: string,
  language: {
    policy: string,
    code: string
  }
  components: ComponentsTemplate[]
}



export interface MessageProps {
  type: string;
  text?: string;
  onlySave: boolean;
  file?: File
  template?: {},
  token: string
  chat?: string

  // "text": messageText, // Se for type text
  // "onlySave": false,
  // "file": {"name": messageText, "url": fileUrl}, // Se for type document, image, audio
  // "type": "image" // image, template, text, audio, document
  // "template": {}

}

export interface ChatProps {

}

export interface MessageChatProps {
  text: string;
  time: string;
  linkImage?: string;
  documentName?: string;

}

interface ChatLogin {
  login: string;
  password: string;
}

interface ChatWhatsAppContextProps {
  getClientMessage(isMessage: boolean): void
  criarChat(telefone: string, botUrl: string, token: string): Promise<{ chatID: string; }>
  loginChat(data: ChatLogin): Promise<{ token: any; queueId: any; }>
  sendImage(data: { file: string; contentType: string; fileName: string; token: string, chat: string; templateToSend: TemplateProps }): Promise<void>
  endOnTemplateChat(id_chat: string, token: string): Promise<void>
  sendDoc(data: { file: string; contentType: string; fileName: string; token: string; chat: string; url?: string }): Promise<void>
  endChat(id_chat: string, token: string): Promise<void>
  enviarMessages(data: MessageProps): Promise<void>
  enviarTemplate(data: MessageProps): Promise<void>
  onlyDeleteChat(id_chat: string, token: string): Promise<void>
  endChatGazin(id_chat: string, token: string, id: number): Promise<string>;
  transferQueue(data: {
    queue: string;
    chatId: string;
    token: string;
  }): Promise<void>
  setChatIdHibrido: React.Dispatch<React.SetStateAction<string>>
  setHasChatAnswer: React.Dispatch<React.SetStateAction<boolean>>
  chatIdHibrido: string
  isChatClintMessage: boolean
  hasChatAnswer: boolean
}

const ChatWhatsAppContext = createContext<ChatWhatsAppContextProps>({} as ChatWhatsAppContextProps);

export const ChatWhatsAppProvider = ({ children }: ChatWhatsAppContextProviderProps) => {
  const queryClient = useQueryClient()
  const [isChatClintMessage, setIsChatClintMessage] = useState(false);
  const [chatIdHibrido, setChatIdHibrido] = useState('')
  const [hasChatAnswer, setHasChatAnswer] = useState(false)
  const { setModal } = useModal()
  const { cookies } = useAuth()
  // const queueId = '6484f3806584e1cae66cb556'
  const queueId = cookies?.whatsapp?.queueId

  const mutateCriarChat = useMutation({
    mutationFn: (data: { providerChatId: string, botUrl: string, token: string }) => apiWhatsApp.post('/chat/start', { providerChatId: data.providerChatId, botId: data.botUrl }, { headers: { token: data.token } }),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['atendimento'] })
    },
    onError: (error: AxiosError) => {
      // console.log(error)
      const data = error?.response?.data as { erro: boolean, mensagem: string }
      setModal(data.mensagem, 'Erro', false, true)
    },
    mutationKey: ['chat']
  })

  const mutateEnviarMenssagem = useMutation({
    mutationFn: (data: MessageProps) => apiWhatsApp.post('/message/attendant', {
      text: data.text,
      type: data.type,
      file: data.file,
      template: data.template,
      onlySave: data.onlySave,
      chat: data.chat || '',
      queueId,
    }, { headers: { token: data.token } }),

  })

  const mutateEnviarTemplate = useMutation({
    mutationFn: (data: MessageProps) => apiWhatsApp.post('/message/attendant', {
      type: data.type,
      template: data.template,
      onlySave: data.onlySave,
      chat: data.chat || '',
      queueId,
    }, { headers: { token: data.token } }),
    mutationKey: ['chat']
  })

  const mutateSendImage = useMutation({
    mutationFn: (data: { file: string, contentType: string, fileName: string, token: string }) => apiWhatsApp.post('/files/post', {
      file: data.file, contentType: data.contentType, fileName: data.fileName
    }, { headers: { token: data.token } }),
    mutationKey: ['chat']
  })

  const mutateTransfer = useMutation({
    mutationFn: (data: { queue: string, chatId: string, token: string }) => apiWhatsApp.put(`/queue/transfer/${data.chatId}`, {
      newQueueId: data.queue
    }, { headers: { token: data.token } }),
    mutationKey: ['chat']
  })

  const mutateDeletarChat = useMutation({
    mutationFn: (data: { chatId: string, token: string }) => apiWhatsApp.post(`/chat/end`, { chatId: data.chatId, queueId, }, { headers: { token: data.token } }),
    mutationKey: ['chat']
  })

  const mutateLoginChat = useMutation({
    mutationFn: (data: ChatLogin) => apiWhatsApp.post('/security/signin', { login: data.login, password: data.password })
  })

  async function loginChat(data: ChatLogin) {
    const { data: dataChat } = await mutateLoginChat.mutateAsync(data)
    return { token: dataChat?.token, queueId: dataChat?.queues[0] }
  }

  async function criarChat(telefone: string, botUrl: string, token: string) {
    const { data } = await mutateCriarChat.mutateAsync({ providerChatId: telefone, botUrl, token })
    return { chatID: data.data.chatId }
  }

  async function enviarMessagens(data: MessageProps) {
    await mutateEnviarMenssagem.mutateAsync(data)
  }

  async function enviarTemplate(data: MessageProps) {
    await mutateEnviarTemplate.mutateAsync(data)
  }


  function getClientMessage(isMessage: boolean) {
    setIsChatClintMessage(isMessage)
  }

  async function endChat(id_chat: string, token: string, credor?: string) {
    await enviarMessagens({ type: 'text', text: 'Muito Obrigado pela nossa conversa. Caso tenha alguma dúvida, entre em contato com a central de atendimento no 0800 647 7778 ou através do nosso portal www.negociegazin.com.br.\nTchau.', onlySave: false, token: token, chat: id_chat, })

    await enviarMessagens({
      type: 'image',
      file: {
        name: '',
        url: 'https://portal-negociegazin-prod.s3.us-east-2.amazonaws.com/banner_encerramento_gazin.png'
      },
      onlySave: false,
      chat: id_chat,
      token: token
    })
    // await queryClient.refetchQueries({ queryKey: ['firstMessages'] })
    await mutateDeletarChat.mutateAsync({ chatId: id_chat, token })
  }

  async function onlyDeleteChat(id_chat: string, token: string) {
    await mutateDeletarChat.mutateAsync({ chatId: id_chat, token })
  }

  async function endOnTemplateChat(id_chat: string, token: string) {
    await mutateDeletarChat.mutateAsync({ chatId: id_chat, token })
  }

  const sendDoc = useCallback(
    async (data: {
      file: string;
      contentType: string;
      fileName: string;
      token: string;
      chat: string;
      url?: string
    }) => {
      let link = ''
      if (!data.url) {
        const { data: dataLink } = await mutateSendImage.mutateAsync(data);
        link = dataLink.link
      } else {
        link = data.url
      }
      const fileType = data.contentType.includes("image")
        ? "image"
        : data.contentType.includes("video")
          ? "video"
          : data.contentType.includes("audio")
            ? "audio"
            : "document";

      await mutateEnviarMenssagem.mutateAsync({
        type: fileType,
        file: {
          name: data.fileName,
          url: link
        },
        onlySave: false,
        chat: data.chat,
        token: data.token,
      });
    },
    [mutateSendImage, mutateEnviarMenssagem]
  );


  async function sendImage(data: { file: string, contentType: string, fileName: string, token: string, chat: string; templateToSend: TemplateProps }) {
    const { data: dataLink } = await mutateSendImage.mutateAsync({ file: data.file, contentType: data.contentType, fileName: data.fileName, token: data.token })

    await enviarMessagens({
      type: 'image',
      file: {
        name: '',
        url: dataLink?.link
      },
      onlySave: false,
      chat: data.chat || '',
      token: data.token
    })

    await queryClient.refetchQueries({ queryKey: ['firstMessages'] })

    setTimeout(async () => {
      await enviarMessagens({ type: 'text', text: 'A imagem da proposta pode apresentar parte das parcelas envolvidas neste acordo, devido às limitações da tela, mas todas estarão informadas na carta acordo que será enviada/recebido após a formalização do mesmo.', onlySave: false, token: data?.token || '', chat: data?.chat })
      await enviarMessagens({ type: 'template', template: data.templateToSend, onlySave: false, token: data?.token || '', chat: data?.chat })
    }, 2000);
  }

  async function endChatGazin(id_chat: string, token: string, id: number) {

    await enviarMessagens({ type: 'text', text: 'Muito Obrigado pela nossa conversa. Caso tenha alguma dúvida, entre em contato com a central de atendimento no 0800 647 7778 ou através do nosso portal www.negociegazin.com.br.\nTchau.', onlySave: false, token: token, chat: id_chat, })


    await enviarMessagens({
      type: "image",
      file: {
        name: "Conheça o portal",
        url: 'https://portal-negociegazin-prod.s3.us-east-2.amazonaws.com/banner_encerramento_gazin.png'
      },
      onlySave: false,
      chat: id_chat,
      token: token,
    });
    // await queryClient.refetchQueries({ queryKey: ['firstMessages'] })
    await mutateDeletarChat.mutateAsync({ chatId: id_chat, token });
    const { data } = await apiOperador.put("cliente/conversa", {
      params: {
        id: id,
        id_conversa: null,
      },
    });

    return data.cliente[0].id_chat;
  }

  async function transferQueue(data: { queue: string, chatId: string, token: string }) {
    await mutateTransfer.mutateAsync(data)
  }


  return (
    <ChatWhatsAppContext.Provider value={{ getClientMessage, isChatClintMessage, criarChat, enviarMessages: enviarMessagens, loginChat, endChat, sendImage, enviarTemplate, sendDoc, endOnTemplateChat, setChatIdHibrido, chatIdHibrido, onlyDeleteChat, hasChatAnswer, setHasChatAnswer, endChatGazin, transferQueue }}>
      {children}
    </ChatWhatsAppContext.Provider>
  );
};

export const useChatWhatsApp = () => useContext(ChatWhatsAppContext);
